import React from 'react';

function Footer() {
  return (
    <footer className="container py-5">
      <div className="row">
        {/* <div className="col-12 col-md">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="d-block mb-2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="14.31" y1="8" x2="20.05" y2="17.94"></line>
            <line x1="9.69" y1="8" x2="21.17" y2="8"></line>
            <line x1="7.38" y1="12" x2="13.12" y2="2.06"></line>
            <line x1="9.69" y1="16" x2="3.95" y2="6.06"></line>
            <line x1="14.31" y1="16" x2="2.83" y2="16"></line>
            <line x1="16.62" y1="12" x2="10.88" y2="21.94"></line>
          </svg>
          <small className="d-block mb-3 text-muted">&copy; 2017-2018</small>
        </div> */}
        <div className="col-6 col-md">
          <h5>Telefone</h5>
          <ul className="list-unstyled text-small">
            <li><a className="text-muted text-decoration-none" target='_blank' rel="noopener noreferrer" href="https://wa.me/5551991848136/?text=ola"><i className="bi bi-whatsapp"></i> WhatsApp</a></li>
            
          </ul>
        </div>
        <div className="col-8 col-md">
          <h5>Email</h5>
          <ul className="list-unstyled text-small">
            <li><a className="text-muted text-decoration-none" href="mailto:psicomanoelamedeiros@gmail.com">psicomanoelamedeiros@gmail.com</a></li>
            
          </ul>
        </div>
        <div className="col-6 col-md">
          <h5>Redes</h5>
          <ul className="list-unstyled text-small">
            <li><a className="text-muted text-decoration-none" target='_blank' rel="noopener noreferrer" href="https://www.instagram.com/psicomanomedeiros/"><i className="bi bi-instagram"></i> @psicomanomedeiros </a></li>

          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
